import controller from '../../../../Resources/Scripts/_Shared/controller';

function carouselBlock(context) {
  const toggle = context.querySelector('.carouselblock__toggle');

  function init() {
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      const isPaused = context.classList.toggle('carouselblock--paused');
      toggle.setAttribute('aria-pressed', String(isPaused));
    });
  }

  return {
    init
  };
}

controller.add('carousel-block', carouselBlock);
